// Ground Control Hazard Assessment verbage

export const GCHASignature = (description: string) =>
  `Add your signature to verify that the ${description} is complete. Notify other workers in the area about any new hazards identified.`;
export const GCHADiscard = (description: string) => `${description} draft discarded`;
export const GCHASuccess = (description: string) => `${description} added`;
export const GCHAError = (description: string) => `Error saving ${description}. Please try again.`;

export const addNewHazardArray = [
  {
    value: 'Nothing new identified',
    forceRemediation: false,
    openNewHazard: false,
  },
  {
    value: 'New hazard present',
    forceRemediation: false,
    openNewHazard: true,
  },
  {
    value: 'New hazard - remediated',
    forceRemediation: true,
    openNewHazard: true,
  },
];
